var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavePattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 123.961V71.8359C271.973 26.8089 519.598 30.1839 742.875 81.9609C1015.63 145.211 1248 117.89 1440 0.000183105L1439.25 123.961L0 123.961Z",
    fill: "url(#paint0_linear_2820_6150)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 123.961V70.7107C201.775 17.8807 452.65 20.8807 752.625 79.7107C1119.75 151.711 1440 0 1440 0L1439.25 123.961H0Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 124.523V70.7107C279.086 -0.377249 528.211 -7.2525 747.375 50.0857C1021.63 121.836 1252.5 105.14 1440 0L1439.25 124.523H0Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 123.961V73.7107C299.5 -4.539 557.375 -17.7893 773.625 33.9607C1098 111.586 1339.12 48.375 1440 0L1439.25 124.523L0 123.961Z",
    fill: "white",
    fillOpacity: 0.35
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2820_6150",
    x1: 730.757,
    y1: 17.5977,
    x2: 730.757,
    y2: 70.5661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavePattern);
export default __webpack_public_path__ + "static/media/wave-pattern.a4dea10a1e25e2b0222a4d46915cb8a6.svg";
export { ForwardRef as ReactComponent };